export default __webpack_public_path__ + "static/linda2-af8f34fc98dd6dd5807fee1cfc602490.jpg";